/**
 * Trending links progressively enhance to fill the TCS search field.
 * Native form submission now handles Enter and View all (R-013), including
 * the section-rendered type=product field. No competing location assignment.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const link = target?.closest('.tcs-predictive__trending-link');

  if (!(link instanceof HTMLAnchorElement)) return;

  const term = link.dataset.searchTerm?.trim();
  if (!term) return;

  // Only take over when we can actually reach the field. If the panel's shape
  // changes upstream, the link stays a link and still works.
  const input = link
    .closest('predictive-search-component')
    ?.querySelector('input[ref="searchInput"]');
  if (!(input instanceof HTMLInputElement)) return;

  event.preventDefault();

  input.value = term;
  input.focus();
  input.dispatchEvent(
    new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }),
  );
});
